import {Component, ViewChild} from "@angular/core";
import {FUIModalsService, FUITextControlComponent} from "@fedelta-pos/ui";

@Component({
    selector: "fhm-sign-url",
    templateUrl: "./signup-url.component.html",
    standalone: false
})
export class SignupUrlComponent {

    @ViewChild("urlControl") urlControl: FUITextControlComponent;

    state: boolean = true;

    url: string;
    title: string;

    constructor(private modalsService: FUIModalsService) {
    }

    close(): void {
        this.modalsService.close(this);
    }

    async copyUrl(): Promise<void> {
        try {
            await navigator.clipboard.writeText(this.url);
        } catch (error) {
            console.log(error);
        }
    }

    selectText(): void {
        this.urlControl.select();
    }
}
